export const convertExamDetailQueryString = (query: any) => {
  const sorts = query.sorts ? query.sorts : 'examDate,desc';
  if (query.sorts == 'examDate,asc') return { sorts: ['examDate,asc', 'examRound,asc'] };
  else
    return {
      sorts: ['examDate,desc', 'examRound,desc'],
    };
};
